import { render, staticRenderFns } from "./SideRight.vue?vue&type=template&id=365cc619&scoped=true&"
import script from "./SideRight.vue?vue&type=script&lang=ts&"
export * from "./SideRight.vue?vue&type=script&lang=ts&"
import style0 from "./SideRight.vue?vue&type=style&index=0&id=365cc619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365cc619",
  null
  
)

export default component.exports